<template>
  <div class="arbitration-detail-common" v-page-loading="false">
    <!-- 基础信息 -->
    <service-detail v-if="showData" :option="option1" v-model="showData">
      <!-- 来电号码脱敏反查 -->
      <template slot="sessionCustomerPhone">
        <BaseDecrypt
          :data="showData.sessionCustomerPhone"
          :params="{ id: showData.id, decryptTypes: ['CUSTOMER_PHONE'] }"
          :formatData="(data) => data.CUSTOMER_PHONE"
        />
      </template>

      <!-- 回电号码脱敏反查 -->
      <template slot="sessionWoCallBackPhone">
        <BaseDecrypt
          :data="showData.sessionWoCallBackPhone"
          :params="{ id: showData.id, decryptTypes: ['CALLBACK_PHONE'] }"
          :formatData="(data) => data.CALLBACK_PHONE"
        />
      </template>
    </service-detail>
    <!-- 首次质检信息 -->
    <service-form :option="option2" v-model="mObj2" hidden>
      <template slot="rcResult">
        {{ M_retestResults[mObj2.rcResult] }}
      </template>
      <template slot="rcScore">
        {{ mObj2.rcScore }}
      </template>
      <template slot="createTime">
        {{ mObj2.createTime }}
      </template>
      <template slot="hitsSlot">
        <span>
          {{ $lang('首次命中情况') }}:
          <span class="total-num">{{ hitSituation.length }}</span>
        </span>
        <template v-if="hitSituation.length">
          <avue-crud ref="params" :data="hitSituation" :option="listOpt2"> </avue-crud>
        </template>
      </template>
    </service-form>
    <!-- 人工质检信息-编辑 -->
    <template v-if="mObj3 && qualityTestingEdit && !mObj4">
      <service-form :option="option3" v-model="mObj3" ref="ruleForm3" hidden>
        <template slot="rcResult">
          <el-radio-group v-model="mObj3.rcResult" @change="handleChangeObj3" :disabled="pageType">
            <template v-for="item in M_retestResultsOption">
              <el-radio :key="item.value" :label="item.value">
                {{ item.label }}
              </el-radio>
            </template>
          </el-radio-group>
        </template>
        <template slot="hitsSlot">
          <span :class="mObj3.rcResult === 'NOT_PASSED' ? 'hitsTitle' : ''">
            {{ $lang('复检命中情况') }}:
            <span class="total-num">{{ hitInspection.length }}</span>
          </span>
          <el-button :title="$lang('添加')" style="display: inline-block; float: right" v-if="!pageType" @click="addArtificialHandler('RECHECK')">
            {{ $lang('添加') }}
          </el-button>
          <avue-crud ref="params" :data="hitInspection" :option="listOpt3">
            <template slot="ruleModelGroupName" slot-scope="{ row }">
              <el-select v-model="row.ruleModelGroupId" :placeholder="$lang('请选择')" :disabled="pageType" @change="getModelName(row, 'RECHECK')">
                <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </template>
            <template slot="ruleModelName" slot-scope="{ row }">
              <el-select v-model="row.ruleModelId" multiple collapse-tags :placeholder="$lang('请选择')" :disabled="pageType" @change="ruleModelNameChange(row, 'RECHECK')">
                <el-option v-for="item in row.modelNameList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </template>
            <template slot="menu" slot-scope="{ row, index }">
              <el-button type="text" :title="$lang('删除')" @click="delArtificialHandler(row, index, 'RECHECK')">
                {{ $lang('删除') }}
              </el-button>
            </template>
          </avue-crud>
        </template>
      </service-form>
    </template>
    <!-- 人工质检信息-查看 -->
    <template v-if="mObj3 && (!qualityTestingEdit || mObj4)">
      <service-form :option="baseOption3" v-model="mObj3" hidden>
        <template slot="rcResult">
          {{ M_retestResults[mObj3.rcResult] }}
        </template>
        <template slot="rcScore">
          {{ mObj3.rcScore }}
        </template>
        <template slot="hitsSlot">
          <span>
            {{ $lang('复检命中情况') }}:
            <span class="total-num">{{ hitInspection.length }}</span>
          </span>
          <template v-if="hitInspection.length">
            <avue-crud ref="params" :data="hitInspection" :option="listOpt2"> </avue-crud>
          </template>
        </template>
        <template slot="rcRemark">
          {{ mObj3.rcRemark }}
        </template>
      </service-form>
    </template>
    <!-- 申诉复检信息-编辑 -->
    <template v-if="mObj4 && qualityTestingEdit&& !mObj6">
      <service-form :option="option4" v-model="mObj4" ref="ruleForm4" hidden>
        <template slot="rcResult">
          <el-radio-group v-model="mObj4.rcResult" @change="handleChangeObj4" :disabled="pageType">
            <template v-for="item in M_retestResultsOption">
              <el-radio :key="item.value" :label="item.value">
                {{ item.label }}
              </el-radio>
            </template>
          </el-radio-group>
        </template>
        <template slot="hitsSlot">
          <span :class="mObj4.rcResult === 'NOT_PASSED' ? 'hitsTitle' : ''">
            {{ $lang('首次申诉质检命中情况') }}:
            <span class="total-num">{{ hitAppeal.length }}</span>
          </span>
          <el-button :title="$lang('添加')" style="display: inline-block; float: right" v-if="!pageType" @click="addArtificialHandler('APPEAL_RECHECK')">
            {{ $lang('添加') }}
          </el-button>
          <avue-crud ref="params" :data="hitAppeal" :option="listOpt3">
            <template slot="ruleModelGroupName" slot-scope="{ row }">
              <el-select v-model="row.ruleModelGroupId" :placeholder="$lang('请选择')" :disabled="pageType" @change="getModelName(row, 'APPEAL_RECHECK')">
                <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </template>
            <template slot="ruleModelName" slot-scope="{ row }">
              <el-select v-model="row.ruleModelId" :placeholder="$lang('请选择')" multiple collapse-tags :disabled="pageType" @change="ruleModelNameChange(row, 'APPEAL_RECHECK')">
                <el-option v-for="item in row.modelNameList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </template>
            <template slot="menu" slot-scope="{ row, index }">
              <el-button type="text" :title="$lang('删除')" @click="delArtificialHandler(row, index, 'APPEAL_RECHECK')">
                {{ $lang('删除') }}
              </el-button>
            </template>
          </avue-crud>
        </template>
      </service-form>
    </template>
    <!-- 申诉质检信息-查看 -->
    <template v-if="mObj4 && (!qualityTestingEdit || mObj6)">
      <service-form :option="baseOption4" v-model="mObj4" hidden>
        <template slot="rcResult">
          {{ M_retestResults[mObj4.rcResult] }}
        </template>
        <template slot="rcScore">
          {{ mObj4.rcScore }}
        </template>
        <template slot="createTime">
          {{ mObj4.createTime }}
        </template>
        <template slot="hitsSlot">
          <span>
            {{ $lang('首次申诉质检命中情况') }}:
            <span class="total-num">{{ hitAppeal.length }}</span>
          </span>
          <template v-if="hitAppeal.length">
            <avue-crud ref="params" :data="hitAppeal" :option="listOpt2"> </avue-crud>
          </template>
        </template>
        <template slot="rcRemark">
          {{ mObj4.rcRemark }}
        </template>
      </service-form>
    </template>
        <!-- 二次申诉复检信息-编辑 -->
    <template v-if="mObj6 && qualityTestingEdit">
      <service-form :option="option6" v-model="mObj6" ref="ruleForm4" hidden>
        <template slot="rcResult">
          <el-radio-group v-model="mObj6.rcResult" @change="handleChangeObj4" :disabled="pageType">
            <template v-for="item in M_retestResultsOption">
              <el-radio :key="item.value" :label="item.value">
                {{ item.label }}
              </el-radio>
            </template>
          </el-radio-group>
        </template>
        <template slot="hitsSlot">
          <span :class="mObj6.rcResult === 'NOT_PASSED' ? 'hitsTitle' : ''">
            {{ $lang('二次申诉质检命中情况') }}:
            <span class="total-num">{{ hitSecondAppeal.length }}</span>
          </span>
          <el-button :title="$lang('添加')" style="display: inline-block; float: right" v-if="!pageType" @click="addArtificialHandler('APPEAL_RECHECK','mObj6')">
            {{ $lang('添加') }}
          </el-button>
          <yl-crud  ref="params" :data="hitSecondAppeal" :option="listOpt3">
            <template slot="ruleModelGroupName" slot-scope="{ row }">
              <el-select v-model="row.ruleModelGroupId" :placeholder="$lang('请选择')" :disabled="pageType" @change="getModelName(row, 'APPEAL_RECHECK')">
                <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </template>
            <template slot="ruleModelName" slot-scope="{ row }">
              <el-select v-model="row.ruleModelId" :placeholder="$lang('请选择')" multiple collapse-tags :disabled="pageType" @change="ruleModelNameChange(row, 'APPEAL_RECHECK','mObj6')">
                <el-option v-for="item in row.modelNameList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </template>
            <template slot="menu" slot-scope="{ row, index }">
              <el-button type="text" :title="$lang('删除')" @click="delArtificialHandler(row, index, 'APPEAL_RECHECK','mObj6')">
                {{ $lang('删除') }}
              </el-button>
            </template>
          </yl-crud>
        </template>
      </service-form>
    </template>
    <!-- 二次申诉质检信息-查看 -->
    <template v-if="mObj6 && !qualityTestingEdit">
      <service-form :option="baseOption6" v-model="mObj6" hidden>
        <template slot="rcResult">
          {{ M_retestResults[mObj6.rcResult] }}
        </template>
        <template slot="rcScore">
          {{ mObj6.rcScore }}
        </template>
        <template slot="createTime">
          {{ mObj6.createTime }}
        </template>
        <template slot="hitsSlot">
          <span>
            {{ $lang('二次申诉质检命中情况') }}:
            <span class="total-num">{{ hitSecondAppeal.length }}</span>
          </span>
          <template v-if="hitSecondAppeal.length">
            <avue-crud ref="params" :data="hitSecondAppeal" :option="listOpt2"> </avue-crud>
          </template>
        </template>
        <template slot="rcRemark">
          {{ mObj6.rcRemark }}
        </template>
      </service-form>
    </template>
    <!-- 提交人工质检/申诉质检 -->
    <div class="btn-group" v-if="qualityTestingEdit && (submitType === 'RECHECK' || submitType === 'APPEAL_RECHECK')">
      <el-button v-if="!isEdit" @click="submitForm('ruleForm', 'next')" :loading="loading">{{ $lang('提交并质检下一条') }}</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">{{ $lang('提 交') }}</el-button>
    </div>
    <!-- 申诉 -->
    <template v-if="appealTesting">
      <service-form :option="option5" v-model="mObj5" ref="ruleForm5" hidden>
        <template slot="files">
          <upload-file
            style="cursor: pointer"
            :title="$lang('附件')"
            v-model="mObj5.files"
            :size="50"
            :limit="8"
            :fileTypeList="['jpg', 'png', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'zip', 'rar']"
            :decs="$lang('(单个文件50M以内，最多上传8个附件，支持格式JPG/JPEG/PNG/PDF/DOC/DOCX/XLS/XLSX/ZIP/RAR)')"
          />
        </template>
      </service-form>
    </template>
    <!-- 申诉提交 -->
    <div class="btn-group" v-if="appealTesting">
      <el-button @click="appealSubmit('ruleForm5', 'reset')" :loading="loading">{{ $lang('取 消') }}</el-button>
      <el-button type="primary" @click="appealSubmit('ruleForm5')" :loading="loading">{{ $lang('提 交') }}</el-button>
    </div>
  </div>
</template>

<script>
import { RULES } from '@/common/utils/validators'
import { DICT } from '@/common/utils/dict'
import { modelMangeApi } from '../model-manage/pool'
import { publicApi } from './pool'
import { mapActions } from 'vuex'
import { haveDuplicateValues } from '@/common/utils/tool'
import BaseDecrypt from './BaseDecrypt.vue'

export default {
  components: {
    BaseDecrypt
  },
  data() {
    return {
      M_retestResultsOption: DICT.M_retestResultsOption,
      M_retestResults: DICT.M_retestResults,
      loading: false,
      submitType: '', // 提交类型
      pageType: this.$route.name.includes('View'), // 查看页面
      qualityTestingEdit: this.$route.name === 'qualityTestingEdit', // 质检页面
      appealTesting: this.$route.name === 'appealTestingEdit', // 申诉页面
      groupList: [], // 模型分支
      allModelNameList: [], // 模型名称
      mObj2: {}, // 首次质检
      hitSituation: [], // 首次质检table
      mObj3: null, // 人工质检信息
      hitInspection: [], // 人工质检信息table
      mObj4: null, // 申诉质检信息
      hitAppeal: [], // 申诉质检信息table
      mObj5: {
        remark: '',
        files: []
      }, // 申诉
      baseScore: 0,
      mObj6: null, // 申诉二次质检信息
      hitSecondAppeal: []// 申诉二次质检信息table
    }
  },
  props: {
    showData: Object
  },
  created() {},
  watch: {
    'showData.id': {
      handler(newVal, oldVal) {
        if (newVal || newVal !== oldVal) {
          this.getGroupList()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      delView: 'tags/delView'
    }),
    // 申诉质检还是人工质检
    ifQualityType() {
      const { fromPage } = this.$route.query
      if (this.qualityTestingEdit) {
        switch (fromPage) {
          case 'taskProcessing':
            return 'taskProcessing'
          case 'qualityAppealProcessing':
            return 'qualityAppealProcessing'
          case 'taskManagement':
            return 'taskProcessing'
          case 'qualityAppealManagement':
            return 'qualityAppealProcessing'
        }
      } else {
        return false
      }
    },
    // 初始化赋值
    setDetail() {
      // 1.首次质检信息
      this.mObj2 = this.showData?.detects.find((res) => res.type === DICT.M_qualityType[1]) || null
      this.hitSituation = this.mObj2?.hits || []
      // 2.人工质检信息
      this.mObj3 = this.showData?.detects.find((res) => res.type === DICT.M_qualityType[2]) || null
      if (this.pageType && this.mObj3 && this.mObj3.status !== DICT.M_allocationStatus[3]) {
        // 查看页面展示已完成
        this.mObj3 = null
      }
      if (this.mObj3) {
        // 人工质检
        const { rcResult, rcScore } = this.mObj2
        this.submitType = 'RECHECK'
        if (!this.pageType) {
          if (!this.mObj3.rcResult) {
            this.mObj3.rcResult = rcResult
          }
          if (!this.mObj3.rcScore) {
            this.mObj3.rcScore = rcScore || 0
          }
        }
        this.hitInspection = this.setArrId(this.mObj3?.hits || [])
        this.isEdit && this.setModelName(this.hitInspection, 'mObj3')
        if (!this.pageType && this.qualityTestingEdit && !this.isEdit) {
          // 编辑
          this.hitInspection = this.setArrId(this.deepClone(this.mObj2?.hits) || [])
          this.setModelName(this.hitInspection, 'mObj3')
        }
        this.mObj3.hitsSlot = !!this.hitInspection?.length
      }

      // 3.申诉质检
      const filterAppealArr =
        this.showData?.detects.filter((res) => {
          if (res.type === DICT.M_qualityType[3]) {
            if (this.pageType) {
              // 查看
              if (res.status === DICT.M_allocationStatus[3]) {
                return res
              }
            } else {
              // 编辑
              return res
            }
          }
        }) || null
      const num = filterAppealArr?.length || 0
      this.mObj4 = num > 0 ? filterAppealArr[0] : null
      this.mObj6 = num > 1 ? filterAppealArr[1] : null
      if (this.pageType && this.mObj4 && this.mObj4.status !== DICT.M_allocationStatus[3]) {
        // 查看页面展示已完成
        this.mObj4 = null
      }
      if (this.mObj4) {
        // 申诉质检
        this.submitType = 'APPEAL_RECHECK'
        const { rcResult, rcScore } = this.mObj3
        if (!this.pageType) {
          // 编辑
          if (!this.mObj4.rcResult) {
            this.mObj4.rcResult = rcResult
          }
          if (!this.mObj4.rcScore) {
            this.mObj4.rcScore = rcScore || 0
          }
        }
        this.hitAppeal = this.setArrId(this.mObj4?.hits || [])
        this.isEdit && this.setModelName(this.hitAppeal, 'mObj4')
        if (!this.pageType && this.qualityTestingEdit && !this.isEdit) {
          // 编辑
          this.hitAppeal = this.setArrId(this.deepClone(this.mObj3?.hits) || [])
          this.setModelName(this.hitAppeal, 'mObj4')
        }
        this.mObj4.hitsSlot = !!this.hitAppeal.length
      }
      // 二次申诉复检
      if (this.pageType && this.mObj6 && this.mObj6.status !== DICT.M_allocationStatus[3]) {
        // 查看页面展示已完成
        this.mObj6 = null
      }
      if (this.mObj6) {
        // 申诉质检
        this.submitType = 'APPEAL_RECHECK'
        const { rcResult, rcScore } = this.mObj3
        if (!this.pageType) {
          // 编辑
          if (!this.mObj6.rcResult) {
            this.mObj6.rcResult = rcResult
          }
          if (!this.mObj6.rcScore) {
            this.mObj6.rcScore = rcScore || 0
          }
        }
        console.log(this.mObj6?.hits, '1111')
        this.hitSecondAppeal = this.setArrId(this.mObj6?.hits || [])
        this.isEdit && this.setModelName(this.hitSecondAppeal, 'mObj6')
        if (!this.pageType && this.qualityTestingEdit && !this.isEdit) {
          // 编辑
          const historyAppeal = filterAppealArr[1]?.hits || []
          const appealList = historyAppeal.length ? historyAppeal : this.mObj4?.hits
          this.hitSecondAppeal = this.setArrId(this.deepClone(appealList) || [])
          this.setModelName(this.hitSecondAppeal, 'mObj6')
          // this.mObj6.rcRemark = historyAppeal.length ? filterAppealArr[0].rcRemark : this.mObj3.rcRemark || ''
        }
        this.mObj6.hitsSlot = !!this.hitSecondAppeal.length
      }
      this.baseScore = 0
      this.setParams()
    },
    // 模型名称,组装数据
    setArrId(data) {
      if (!data || !data?.length) return []
      return data?.map((res) => {
        const { ruleModelGroupId = [], ruleModelId = null } = res
        res.ruleModelGroupId = ruleModelGroupId
        res.ruleModelIdOldValue = ruleModelId
        return res
      })
    },
    // 获取模型名称
    setModelName(listData, objName) {
      if (!listData || !listData?.length) return
      listData.forEach((res) => {
        this.reqModelList(res, objName)
      })
    },
    // 页面进来.存储params传递过来的参数,防止刷新丢失
    setParams() {
      const { params = null, name = null } = this.$route
      if (name && params?.prevListParams) {
        window.localStorage.setItem(name + params.type, JSON.stringify(params))
      }
    },
    // 复检结果
    changeApprovalStatus(value) {
      this.mObj3.rcResult = value
    },
    // 模型分类
    async getGroupList() {
      try {
        const params = {}
        const taskSource = this.showData?.taskSource
        if (taskSource) {
          params.source = taskSource
        }
        const { data } = await modelMangeApi.reqGroup(params)
        this.groupList = data
      } finally {
        this.setDetail()
      }
    },
    // 模型名称
    async getModelName(row, type) {
      row.ruleModelId = ''
      this.reqModelList(row)
    },
    // 请求模型名称
    async reqModelList(row, objName) {
      const { ruleModelGroupId } = row
      if (!ruleModelGroupId) return
      const { data } = await modelMangeApi.reqList({ current: 1, size: 99999, groupId: ruleModelGroupId })
      this.$set(row, 'modelNameList', data?.records || [])
      const oVal = row.ruleModelIdOldValue
      if (oVal) {
        this.$set(row, 'ruleModelId', row.ruleModelIdOldValue ? [row.ruleModelIdOldValue] : [])
        if (objName) {
          let rcRemarkStr = this[objName]?.rcRemark || ''
          data?.records?.forEach(({ id, comment }) => {
            if (id === oVal && comment) {
              // if (rcRemarkStr !== comment) {
              rcRemarkStr = rcRemarkStr + comment || ''
              // }
            }
          })
          if (rcRemarkStr && rcRemarkStr.length > 1000) {
            this[objName].rcRemark = rcRemarkStr.substring(0, 1000)
          }
          this[objName].rcRemark = rcRemarkStr
        }
        delete row.ruleModelIdOldValue
      }
    },
    // 获取所有模型名称
    async getAllModelName() {
      const { data } = await modelMangeApi.reqList({ current: 1, size: 99999 })
      this.allModelNameList = data?.records || []
    },
    // 添加
    addArtificialHandler(type, obj) {
      const pushArr = this.getTableKey(type, obj)
      const mObj = obj || (type === 'RECHECK' ? 'mObj3' : 'mObj4')
      if (this.ifNoEdit(type, obj)) return
      this[pushArr].push({
        ruleModelGroupId: '',
        ruleModelId: '',
        modelNameList: []
      })
      this[mObj].hitsSlot = !!this[pushArr].length
      this[mObj].rcResult = 'NOT_PASSED'
    },
    // 判断是否有未编辑的
    ifNoEdit(type, obj) {
      const pushArr = this.getTableKey(type, obj)
      return this[pushArr].find((data) => {
        if (!data.ruleModelGroupId) {
          return this.$message.warning(this.$lang('请选择模型分类'))
        }
        if (!data.ruleModelId) {
          return this.$message.warning(this.$lang('请选择模型名称'))
        }
      })
    },
    // 删除
    delArtificialHandler(rowData, index, type, obj) {
      const pushArr = this.getTableKey(type, obj)
      this[pushArr].splice(index, 1)
      const sum = this[pushArr]?.reduce((a, b) => {
        return (a.score || 0) + (b.score || 0)
      }, 0)
      this.baseScore = sum
      // 设置评分
      this.setScore(type, obj)
    },
    // 选择模型不能重复
    ruleModelNameChange(row, type, obj) {
      const pushArr = this.getTableKey(type, obj)
      let newActiveObj = null
      const ruleModelIds = row.ruleModelId
      const lastId = ruleModelIds[ruleModelIds.length - 1]
      // 当前选中的模型名称
      row.modelNameList.forEach((res) => {
        if (res.id === lastId) {
          newActiveObj = res
        }
      })
      // 判断是否有重复id
      const findArr = this[pushArr].filter((data) => {
        if (haveDuplicateValues(data.ruleModelId, row.ruleModelId)) {
          return data
        }
      })
      // 获取当前行分数
      const { modelNameList, ruleModelId } = row
      modelNameList.forEach((item) => {
        if (ruleModelId?.includes(item.id)) {
          const score = item?.score || 0
          this.baseScore = (this.baseScore || 0) + score
          row.score = item?.score
        }
      })
      if (findArr.length > 1) {
        // 有重复的
        row.ruleModelId.pop()
        return this.$message.error(this.$lang('命中模型名称不允许重复！'))
      } else {
        // 没有重复的
        // 设置复检评语
        if (newActiveObj) {
          const mObj = type === 'RECHECK' ? 'mObj3' : this.mObj6 ? 'mObj6' : 'mObj4'
          const symbolStr = this[mObj].rcRemark && newActiveObj?.comment ? ';' : ''
          this[mObj].rcRemark = `${this[mObj].rcRemark || ''}${symbolStr}${newActiveObj?.comment || ''}`
          const rcRemarkStr = this[mObj].rcRemark
          if (rcRemarkStr && rcRemarkStr.length > 1000) {
            this[mObj].rcRemark = rcRemarkStr.substring(0, 1000)
          }
        }
      }
      // 设置评分
      this.setScore(type)
    },
    // 获取操作的表格key
    getTableKey(type, obj) {
      return type === 'RECHECK' ? 'hitInspection' : obj ? 'hitSecondAppeal' : 'hitAppeal'
    },
    validate(cb) {
      if (this.$refs.arbitration && this.$refs.arbitration.validate) {
        this.$refs.arbitration.validate((val) => {
          cb(val)
        })
      }
      if (this.$refs.appeal && this.$refs.appeal.validate) {
        this.$refs.appeal.validate((val) => {
          cb(val)
        })
      }
    },
    // 返回到列表页
    goBackPage() {
      this.delView(this.$route).then(({ visitedViews }) => {
        const { fromTitle, fromPage } = this.$route.query
        this.$router.push({
          name: fromPage,
          query: {
            title: this.$lang(fromTitle),
            fromTitle,
            fromPage,
            moduleCode: 'serviceQualityQtIndex'
          },
          params: {
            reload: true
          }
        })
      })
    },
    // 处理下一条
    goNextPage(id, sessionParams) {
      const { name, meta } = this.$route
      const { fromTitle, fromPage } = this.$route.query
      this.$router.push({
        name: name,
        query: {
          title: this.$lang(meta.title),
          fromTitle,
          fromPage,
          moduleCode: 'serviceQualityQtIndex'
        },
        params: {
          type: sessionParams?.type,
          prevListParams: sessionParams?.prevListParams,
          id,
          reload: true
        }
      })
    },
    // 提交
    submitForm(formName, type) {
      // const rGType = this.submitType === 'RECHECK'
      const rGType = !this.mObj4 && !this.mObj6 // 人工
      if (rGType) {
        // 人工质检信息
        if (this.mObj3.rcResult === 'NOT_PASSED') {
          // 不通过
          if (this.hitInspection.length === 0) {
            return this.$message.error(this.$lang('请添加复检命中情况'))
          }
        }
        // 判断是否有未编辑的
        if (this.ifNoEdit(this.submitType)) return
      }
      // 申诉质检
      if (!rGType) {
        if (this.mObj6) {
          if (this.mObj6.rcResult === 'NOT_PASSED') {
            if (this.hitSecondAppeal.length === 0) {
              return this.$message.error(this.$lang('请添加复检命中情况'))
            }
          }
          // 判断是否有未编辑的
          if (this.ifNoEdit(this.submitType, 'mObj6')) return
        } else {
          if (this.mObj4.rcResult === 'NOT_PASSED') {
            if (this.hitAppeal.length === 0) {
              return this.$message.error(this.$lang('请添加复检命中情况'))
            }
          }
          // 判断是否有未编辑的
          if (this.ifNoEdit(this.submitType)) return
        }
      }
      let params = {}
      const mObj = rGType ? 'mObj3' : this.mObj6 ? 'mObj6' : 'mObj4'
      const pushArr = this.getTableKey(rGType ? 'RECHECK' : 'APPEAL_RECHECK', this.mObj6 ? 'mObj6' : '')
      const { rcResult, rcScore, rcRemark, id } = this[mObj]
      params = {
        rcResult,
        rcScore,
        rcRemark,
        ruleModelIds: this[pushArr].map((o) => o?.ruleModelId)?.flat(Infinity),
        taskId: this.showData.id,
        taskDetectId: id,
        needNext: false
      }
      const { name } = this.$route
      const getParams = window.localStorage.getItem(name + this.$route?.params?.type)
      const sessionParams = getParams ? JSON.parse(getParams) : null
      if (type === 'next') {
        params.queryParams = sessionParams?.prevListParams
        params.needNext = true
      }
      // 获取type类型,质检任务管理 RECHECK，申诉任务管理 APPEAL_RECHECK
      // 2,8,11,3,4 :质检任务管理 1,5,9,10,6,7 :申诉
      const getType = this.$route.params.type
      const settype = ['02', '08', '011', '03', '04'].includes(getType) ? 'RECHECK' : 'APPEAL_RECHECK';
      params.type = settype
      formName = rGType ? 'ruleForm3' : 'ruleForm4'
      let reqApi = 'reqRecheck'
      this.isEdit && (reqApi = 'reqRecheckEdit') // 管理页面的编辑
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          publicApi[reqApi](params).then(({ data, msg }) => {
            this.$message.success(msg)
            if (type === 'next' && data) {
              // 提交并处理下一条
              this.goNextPage(data, sessionParams)
            } else {
              // 提交
              setTimeout(() => {
                this.goBackPage()
              }, 800)
            }
          })
        }
      })
    },
    // 申诉取消/提交
    appealSubmit(formName, type) {
      // 取消
      if (type === 'reset') {
        return this.goBackPage()
      }
      const { remark, files } = this.mObj5
      // 提交
      const params = {
        remark,
        taskId: this.showData.id,
        files: files?.map((res) => {
          const { name, path } = res
          return {
            title: name,
            url: path
          }
        })
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          publicApi.reqAppeal(params).then(({ msg }) => {
            this.$message.success(msg)
            setTimeout(() => {
              this.goBackPage()
            }, 800)
          })
        }
      })
    },
    handleChangeObj4(val) {
      this.setScore('APPEAL_RECHECK')
      this.mObj4.hitsSlot = !!this.hitAppeal.length
    },
    handleChangeObj3(val) {
      this.setScore('RECHECK')
      this.mObj3.hitsSlot = !!this.hitInspection.length
    },
    // 获取分数
    getScore(totalrcScore) {
      const sValue = (totalrcScore - (this.baseScore || 0)).toFixed(1)
      return sValue < 0 ? 0 : sValue
    },
    // 设置复检分数
    setScore(type, obj) {
      const typeObj = {
        RECHECK: 'mObj3',
        APPEAL_RECHECK: 'mObj4'
      }
      this[this.mObj6 ? this.mObj6 : typeObj[type]].rcScore = this.getScore(this[typeObj[type]].rcScore)
      this.$forceUpdate()
    }
  },
  computed: {
    isEdit() {
      return this.$route.query.title === this.$lang('编辑')
    },
    baseObj() {
      // IM CC
      let objArr = []
      const isIM = this.showData?.taskSource === 'IM'
      if (this.showData?.taskSource === 'WO') {
        // 工单质检
        objArr = [
          {
            label: '任务ID',
            prop: 'taskBizId'
          },
          {
            label: '任务生成时间',
            prop: 'createTime'
          },
          {
            label: '工单类型',
            prop: 'sessionWoType',
            formatter({ sessionWoType }) {
              const item = DICT.WO_TYPE.find((o) => o.value === sessionWoType) || {}
              return item.label
            }
          },
          {
            label: '工单渠道',
            prop: 'sessionWoChannel',
            formatter({ sessionWoChannel }) {
              const item = DICT.WO_CHANNEL.find((o) => o.value === sessionWoChannel) || {}
              return item.label
            }
          },
          {
            label: '工单编号',
            prop: 'sessionWoNo'
          },
          {
            label: '运单编号',
            prop: 'sessionWaybillNos',
            formatter: ({ sessionWaybillNos }) => {
              return (sessionWaybillNos && sessionWaybillNos.length) ? sessionWaybillNos : '--'
            }
          },
          {
            label: '工单一级类型',
            prop: 'sessionWoFirstTypeName'
          },
          {
            label: '工单二级类型',
            prop: 'sessionWoSecondTypeName'
          },
          {
            label: '工单登记时间',
            prop: 'sessionStartTime'
          },
          {
            label: '回电号码',
            prop: 'sessionWoCallBackPhone'
          },
          {
            label: '问题描述',
            prop: 'sessionWoDescribe'
          },
          {
            label: '网点名称',
            prop: 'sessionNetworkName'
          },
          {
            label: '网点编码',
            prop: 'sessionNetworkCode'
          },
          {
            label: '所属代理区',
            prop: 'sessionAgencyName'
          }
        ]
      } else {
        // IM/CC
        objArr = [
          {
            label: '会话ID',
            prop: 'sessionId'
          },
          {
            label: '客户名称',
            prop: 'sessionCustomerName',
            display: isIM
          },
          {
            label: '运单号',
            prop: 'sessionWaybillNos',
            formatter: ({ sessionWaybillNos }) => {
              return (sessionWaybillNos && sessionWaybillNos.length) ? sessionWaybillNos : '--'
            }
          },
          {
            label: '来电号码',
            prop: 'sessionCustomerPhone',
            search: true,
            slot: true,
            sort: 6,
            width: 140,
            display: !isIM
          },
          {
            label: '任务ID',
            prop: 'taskBizId'
          },
          {
            label: '进线开始时间',
            prop: 'sessionStartTime'
          },
          {
            label: '进线结束时间',
            prop: 'sessionEndTime',
            display: isIM
          },
          {
            label: '客户评价',
            prop: 'sessionEvalLevel',
            formatter: ({ sessionEvalLevel }) => {
              const item = DICT.M_sessionEvalLevel.find((o) => o.value.includes(sessionEvalLevel)) || {}
              return item.label
            }
          },
          {
            label: '工单编号',
            prop: 'sessionWoNo'
          },
          {
            label: '转单类型',
            prop: 'sessionWoTransferType'
          },
          {
            label: '挂机方',
            prop: 'sessionEndRole',
            formatter({ sessionEndRole }) {
              const item = DICT.M_hangingParty.find((o) => o.value === sessionEndRole) || {}
              return item.label
            }
          },
          {
            label: '客服姓名',
            prop: 'sessionAgentName'
          },
          {
            label: '进线渠道',
            prop: 'sessionChannelName',
            display: isIM
          },
          {
            label: '坐席分机',
            prop: 'sessionAgentPhoneExt',
            display: !isIM
          }
        ]
      }
      return objArr
    },
    // 基础信息
    option1() {
      const that = this
      const opt = {
        group: [
          {
            label: '基础信息',
            column: [...that.baseObj]
          }
        ]
      }
      return opt
    },
    // 首次质检信息
    option2() {
      const that = this
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: []
      }
      const machineMsg = !that.mObj2
        ? null
        : {
          label: '首次质检信息',
          column: [
            {
              label: '首次结果',
              prop: 'rcResult'
            },
            // {
            //   label: '机器评分',
            //   prop: 'rcScore'
            // },
            {
              label: '首次扣罚金额',
              prop: 'rcScore'
            },
            {
              label: '质检时间',
              prop: 'createTime'
            },
            {
              label: '',
              prop: 'hitsSlot',
              span: 24
            }
          ]
        }
      if (machineMsg) {
        opt.group.push(machineMsg)
      }
      return opt
    },
    // 首次命中情况表格
    listOpt2() {
      return {
        tableHeight: '130px',
        search: false,
        menu: false,
        ignorePermission: true,
        column: [
          {
            label: '模型分类',
            prop: 'ruleModelGroupName'
          },
          {
            label: '模型名称',
            prop: 'ruleModelName'
          }
        ]
      }
    },
    // 人工质检信息
    option3() {
      const that = this
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: []
      }
      const machineMsg = !that.mObj3
        ? null
        : {
          label: '人工质检信息',
          column: [
            {
              label: '复检结果',
              prop: 'rcResult',
              // type: 'select',
              // dicData: DICT.M_retestResultsOption,
              rules: [RULES.required],
              disabled: that.pageType,
              slot: true,
              change() {
                that.mObj3.hitsSlot = !!that.hitInspection.length
              }
            },
            // {
            //   label: '复检评分',
            //   prop: 'rcScore',
            //   rules: [RULES.required, RULES.oneDecimal],
            //   disabled: that.pageType
            // },
            {
              label: '扣罚金额',
              prop: 'rcScore',
              rules: [RULES.required, RULES.intTo9999],
              disabled: that.pageType
            },
            {
              label: '',
              prop: 'hitsSlot',
              rules: that.mObj3.rcResult === 'NOT_PASSED' ? [RULES.required] : '',
              span: 24
            },
            {
              label: '复检评语',
              prop: 'rcRemark',
              type: 'textarea',
              span: 24,
              maxlength: 1000,
              minRows: 5,
              disabled: that.pageType
            }
          ]
        }
      if (machineMsg) {
        opt.group.push(machineMsg)
      }
      return opt
    },
    // 人工质检信息表格
    listOpt3() {
      const that = this
      return {
        tableHeight: '130px',
        search: false,
        menu: !that.pageType,
        ignorePermission: true,
        column: [
          {
            label: '模型分类',
            prop: 'ruleModelGroupName',
            slot: true
          },
          {
            label: '模型名称',
            prop: 'ruleModelName',
            slot: true
          }
        ]
      }
    },
    // 申诉复检信息
    option4() {
      const that = this
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: []
      }
      const machineMsg = !that.mObj4
        ? null
        : {
          label: '首次申诉质检信息',
          column: [
            {
              label: '首次申诉质检结果',
              prop: 'rcResult',
              // type: 'select',
              // dicData: DICT.M_retestResultsOption,
              rules: [RULES.required],
              disabled: that.pageType,
              slot: true,
              change() {
                that.mObj4.hitsSlot = !!that.hitAppeal.length
              }
            },
            // {
            //   label: '申诉复检评分',
            //   prop: 'rcScore',
            //   rules: [RULES.required, RULES.oneDecimal],
            //   disabled: that.pageType
            // },
            {
              label: '首次申诉扣罚金额',
              prop: 'rcScore',
              rules: [RULES.required, RULES.intTo9999],
              disabled: that.pageType
            },
            {
              label: '',
              prop: 'hitsSlot',
              rules: that.mObj3.rcResult === 'NOT_PASSED' ? [RULES.required] : '',
              span: 24
            },
            {
              label: '首次申诉质检评语',
              prop: 'rcRemark',
              type: 'textarea',
              maxlength: 1000,
              span: 24,
              minRows: 5,
              disabled: that.pageType
            }
          ]
        }
      if (machineMsg) {
        opt.group.push(machineMsg)
      }
      return opt
    },
    // 申诉复检信息
    option6() {
      const that = this
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: []
      }
      const machineMsg = !that.mObj6
        ? null
        : {
          label: '二次申诉质检信息',
          column: [
            {
              label: '二次申诉质检结果',
              prop: 'rcResult',
              // type: 'select',
              // dicData: DICT.M_retestResultsOption,
              rules: [RULES.required],
              disabled: that.pageType,
              slot: true,
              change() {
                that.mObj6.hitsSlot = !!that.hitAppeal.length
              }
            },
            // {
            //   label: '申诉复检评分',
            //   prop: 'rcScore',
            //   rules: [RULES.required, RULES.oneDecimal],
            //   disabled: that.pageType
            // },
            {
              label: '二次申诉扣罚金额',
              prop: 'rcScore',
              rules: [RULES.required, RULES.isNumber],
              disabled: that.pageType
            },
            {
              label: '',
              prop: 'hitsSlot',
              rules: that.mObj3.rcResult === 'NOT_PASSED' ? [RULES.required] : '',
              span: 24
            },
            {
              label: '二次申诉质检评语',
              prop: 'rcRemark',
              type: 'textarea',
              maxlength: 1000,
              span: 24,
              minRows: 5,
              disabled: that.pageType
            }
          ]
        }
      if (machineMsg) {
        opt.group.push(machineMsg)
      }
      return opt
    },
    // 申诉
    option5() {
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: [
          {
            label: '申诉',
            column: [
              {
                label: '申诉原因',
                prop: 'remark',
                type: 'textarea',
                maxlength: 1000,
                rules: [RULES.required],
                span: 24,
                minRows: 5
              },
              {
                label: '',
                prop: 'files',
                slot: true,
                span: 24
              }
            ]
          }
        ]
      }
      return opt
    },
    // 人工质检和申诉质检预览
    baseOption3() {
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: [
          {
            label: '人工质检信息',
            column: [
              {
                label: '复检结果',
                prop: 'rcResult'
              },
              // {
              //   label: '复检评分',
              //   prop: 'rcScore'
              // },
              {
                label: '扣罚金额',
                prop: 'rcScore'
              },
              {
                label: '',
                prop: 'hitsSlot',
                span: 24
              },
              {
                label: '复检评语',
                prop: 'rcRemark'
              }
            ]
          }
        ]
      }
      return opt
    },
    // 申诉复检信息预览
    baseOption4() {
      const that = this
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: []
      }
      const machineMsg = !that.mObj4
        ? null
        : {
          label: '首次申诉质检信息',
          column: [
            {
              label: '首次申诉质检结果',
              prop: 'rcResult'
            },
            // {
            //   label: '申诉复检评分',
            //   prop: 'rcScore'
            // },
            {
              label: '首次申诉扣罚金额',
              prop: 'rcScore'
            },
            {
              label: '',
              prop: 'hitsSlot',
              span: 24
            },
            {
              label: '首次质检申诉评语',
              prop: 'rcRemark'
            }
          ]
        }
      if (machineMsg) {
        opt.group.push(machineMsg)
      }
      return opt
    },
    // 申诉复检信息预览
    baseOption6() {
      const that = this
      const opt = {
        menuBtn: false,
        emptyBtn: false,
        group: []
      }
      const machineMsg = !that.mObj6
        ? null
        : {
          label: '二次申诉质检信息',
          column: [
            {
              label: '二次申诉质检结果',
              prop: 'rcResult'
            },
            // {
            //   label: '申诉复检评分',
            //   prop: 'rcScore'
            // },
            {
              label: '二次申诉扣罚金额',
              prop: 'rcScore'
            },
            {
              label: '',
              prop: 'hitsSlot',
              span: 24
            },
            {
              label: '二次申诉评语',
              prop: 'rcRemark'
            }
          ]
        }
      if (machineMsg) {
        opt.group.push(machineMsg)
      }
      return opt
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-group {
  text-align: right;
  padding-bottom: 40px;
}
.total-num {
  display: inline-block;
  background-color: #e60012;
  min-width: 16px;
  padding: 0 4px;
  height: 16px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #fff;
}
.hitsTitle::before {
  content: '*';
  color: #f56c6c;
}
::v-deep .el-tag--info:nth-child(1) {
  .el-select__tags-text {
    max-width: 50px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-icon-close {
    top: 3px;
  }
}
::v-deep .el-select__tags span:nth-child(1) {
  display: flex;
}
::v-deep .el-table{
  width: 500px;
}
</style>
